import { render, staticRenderFns } from "./CustomersBulkEdit.vue?vue&type=template&id=01a5d3e6"
import script from "./CustomersBulkEdit.vue?vue&type=script&lang=js"
export * from "./CustomersBulkEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports